import { useTranslation } from 'react-i18next';
import DeviceDenied from './DeviceDenied';
import NoDevice from './NoDevice';
import ErrorTitle from './ErrorTitle';

const MicrophonePermissionBlockedError = () => {
  const { t } = useTranslation();
  return (
    <>
      <ErrorTitle title={t("We can't access your microphone")} />
      <DeviceDenied device="microphone" reason="blocked" />
    </>
  );
};

const MicrophonePermissionDeniedError = () => {
  const { t } = useTranslation();
  return (
    <>
      <ErrorTitle title={t("We can't access your microphone")} />
      <DeviceDenied device="microphone" reason="denied" />
    </>
  );
};

const NoMicrophoneError = () => {
  const { t } = useTranslation();
  return (
    <>
      <ErrorTitle
        title={t('We could not detect any {{device}}', {
          device: t('microphone'),
        })}
      />
      <NoDevice device="microphone" />
    </>
  );
};

export {
  MicrophonePermissionBlockedError,
  MicrophonePermissionDeniedError,
  NoMicrophoneError,
};
